import React from 'react'

const OutOfNetwork = ({ width = '15px', height = '15px', color = '#F68F31' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-outofnetwork" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M5,0.65 C7.40243866,0.65 9.35,2.59756134 9.35,5 C9.35,7.40243866 7.40243866,9.35 5,9.35 C2.59756134,9.35 0.65,7.40243866 0.65,5 C0.65,2.59756134 2.59756134,0.65 5,0.65 Z M7.63204492,3.18023361 L3.18023361,7.63204492 C3.69686232,7.98991218 4.3239451,8.19958678 5,8.19958678 C6.76708298,8.19958678 8.19958678,6.76708298 8.19958678,5 C8.19958678,4.3239451 7.98991218,3.69686232 7.63204492,3.18023361 Z M5,1.80041322 C3.23291702,1.80041322 1.80041322,3.23291702 1.80041322,5 C1.80041322,5.6760549 2.01008782,6.30313768 2.36795508,6.81976639 L6.81976639,2.36795508 C6.30313768,2.01008782 5.6760549,1.80041322 5,1.80041322 Z"
          id="Combined-Shape"
          fill={color}
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}

export default OutOfNetwork
